const rail = {
  rails: "Rel", // translated 
  senior: "Warga emas", // translated 
  seniors: "Warga emas", // translated 
  youths: "Belia", // translated 
  yearOld: "tahun", // translated 
  yearsOld: "tahun", // translated 
};





export default rail;
